import { useContext } from 'react';
import ForwardRefContext from 'src/contexts/ForwardRefContext';
import { ScrollToEdgeButton } from 'src/components/ScrollToEdgeButton';
import styles from './ScrollToButtonMessageListButton.module.scss';
import {
  useCurrentConversationStatuses,
  useConversationParams,
  useIntersectionObserver,
  useComparingConversationsParams,
} from 'src/hooks';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import cn from 'classnames';
import { ItemLocation } from '@virtuoso.dev/message-list';

export const ScrollToButtonMessageListButton = () => {
  const {
    mainMessageListRef,
    endOfMessagesRef,
    threadMessageListRef,
    compareMessageListRef,
  } = useContext(ForwardRefContext);
  const { threadInputBoxFiles } = useContext(ThreadInputBoxContext);

  const { isCurrentConversationLoading } = useCurrentConversationStatuses();
  const { isLandingPage } = useConversationParams();
  const { isCompareMode } = useComparingConversationsParams();

  // TODO(olha): WIP Virtuoso
  const isVisibleMessageListBottom = useIntersectionObserver(endOfMessagesRef, {
    threshold: 1.0,
  });

  const handleClick = () => {
    const args: ItemLocation = {
      index: 'LAST',
      align: 'end',
      behavior: 'instant',
    };

    mainMessageListRef.current?.scrollToItem(args);

    if (isCompareMode) {
      compareMessageListRef.current?.scrollToItem(args);
    }
  };

  if (isLandingPage) {
    return null;
  }

  return (
    <ScrollToEdgeButton
      scrollableContainerRef={threadMessageListRef}
      direction="down"
      isVisible={!isVisibleMessageListBottom && !isCurrentConversationLoading}
      className={cn(styles.root, {
        [styles.withAttachedFiles]:
          Object.keys(threadInputBoxFiles || {}).length > 0,
      })}
      onClick={handleClick}
    />
  );
};
